import { LOAD_FEATURE_FLAGS, SET_FEATURE_FLAG, UNSET_FEATURE_FLAG } from '../constants/ActionTypes'

/**
 * @typedef {ReturnType<typeof setFeatureFlag> | ReturnType<typeof unsetFeatureFlag> | ReturnType<typeof load>} FeatureFlagsActions
 */

/**
 * @param {String} flagName
 * @return {{ type: 'SET_FEATURE_FLAG', flagName: String }}
 */
// Leaving in case we add another feature flag in due course.
// eslint-disable-next-line no-unused-vars
const setFeatureFlag = (flagName) => ({
  type: SET_FEATURE_FLAG,
  flagName,
})

/**
 * @param {String} flagName
 * @return {{ type: 'UNSET_FEATURE_FLAG', flagName: String }}
 */
// Leaving in case we add another feature flag in due course.
// eslint-disable-next-line no-unused-vars
const unsetFeatureFlag = (flagName) => ({
  type: UNSET_FEATURE_FLAG,
  flagName,
})

/**
 * @param {boolean} patching
 * @param {Record<String, boolean>} featureFlags
 * @return {{ type: 'LOAD_FEATURE_FLAGS', patching: boolean, featureFlags: Record<String, boolean> }}
 */
export const load = (patching, featureFlags) => ({
  type: LOAD_FEATURE_FLAGS,
  patching,
  featureFlags,
})
